import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { Member } from 'src/app/model/member';

@Component({
  selector: 'member-overview',
  templateUrl: 'member-overview.html'
})

export class MemberOverviewComponent {
  @Input("header") header: string;
  @Input("member") member: Member;

  constructor() { }
}
